import { connect } from 'react-redux';
import { editDeviation } from '../../../redux/deviations/actionCreators';
var mapDispatchToProps = function (dispatch, _a) {
    var deviation = _a.deviation;
    return ({
        editTier: function () { return dispatch(editDeviation({ deviation: deviation })); },
    });
};
export default connect(null, mapDispatchToProps);
//# sourceMappingURL=EditTier.container.js.map